import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";

import styles from "./index.module.scss";
import "./Datepicker.css";

import { Form, Spinner } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { AiOutlineSearch } from "react-icons/ai";
import { IoChevronDownSharp, IoCloseOutline } from "react-icons/io5";
import { ReactComponent as BackIcon } from "./images/back.svg";
import { ReactComponent as CameraIcon } from "./images/camera.svg";
import moment from "moment";

export const BackButton = ({
  text = "",
  classes = "",
  handleBackButton = () => { },
}) => {
  return (
    <div
      className={`${styles.BackButton} ${classes}`}
      onClick={handleBackButton}
    >
      <span className={styles.icon}>
        <BackIcon />
      </span>
      <Description text={text} />
    </div>
  );
};

export const Input = React.forwardRef(
  (
    {
      type = "text",
      classes = "mt-1 mb-2",
      labelContainerClasses = "",
      label = "",
      labelClasses = "",
      labelItem = undefined,
      inputClasses = "",
      size = "lg",
      placeholder = "",
      name = "",
      disabled = false,
      as = "input",
      maxLength,
      colored = false,
      prefixIcon = undefined,
      sufixIcon = undefined,
      rows = undefined,
      isOption = false,
      isActiveOption = false,
      onClick = () => { },
      bg = true,
      minDate = undefined,
      minTime = undefined,
      ...rest
    },
    ref // `ref` is passed as the second argument
  ) => {
    return (
      <div
        className={`${styles.Input} ${isOption ? styles.Option : ""} ${bg ? styles.bg : styles.modalInput
          } w-100 d-flex flex-column justify-content-start ${classes}`}
      >
        <div className="w-100 d-flex flex-column">
          {!label && !labelItem ? (
            ""
          ) : (
            <div
              className={`d-flex flex-row align-items-center justify-content-between ${labelContainerClasses}`}
            >
              {!label ? (
                ""
              ) : (
                <LabelHeader
                  text={label}
                  classes={`${styles.label} ${labelClasses} w-85`}
                />
              )}
              {!labelItem ? "" : labelItem}
            </div>
          )}

          <div className={`${styles.InputContainer}`}>
            {!prefixIcon ? (
              <></>
            ) : (
              <span className={styles.icon}>{prefixIcon}</span>
            )}
            {type === 'date' ?
              <DatePicker
                {...rest}
                // onChange={(e) => {
                //   const now = moment(new Date());
                //   let value = moment(e);
                //   if (value.isSameOrBefore(now)) {
                //     value = now.add(1, 'hours').startOf('hour'); // Round to next hour
                //   } else {

                //     const minutes = value.minutes();
                //     console.log("minutes : ", minutes);
                //     value.minutes(minutes < 30 ? 0 : 30).seconds(0);
                //   }

                //   return rest.onChange(value.toDate());
                // }}
                timeIntervals={1}
                placeholderText="Date/Time"
                selected={rest.value}
                showTimeSelect
                timeFormat="HH:mm"
                dateFormat="yyyy/MM/dd HH:mm"
                minDate={minDate || moment()}
                minTime={minTime ? minTime : !rest.value ? moment().toDate() : moment(rest.value).isSame(moment(), "day") ? moment().toDate() : moment().startOf("day").toDate()} // Disable past times only for today
                maxTime={moment().endOf("day").toDate()}
                className={`form-control ${styles.FormInput} ${inputClasses} mt-3`}
              /> :
              <Form.Control
                {...rest} // Spread the rest of the props including the ref and others
                ref={ref} // Use the forwarded ref here
                type={type}
                size={size}
                className={`
                  ${styles.FormInput}
                   ${inputClasses}
                    ${colored ? styles.colored : ""} 
                    ${prefixIcon ? styles.withIcon : ""} ${sufixIcon ? styles.withSufixIcon : ""} 
                    ${as === "input" ? styles.inputArea : styles.textArea}
                     mt-1`}
                placeholder={placeholder}
                disabled={disabled}
                as={as}
                maxLength={maxLength}
                rows={rows}
                onFocus={(e) => {
                  setTimeout(() => {
                    e.target.scrollIntoView({ behavior: "smooth", block: "center" });
                  }, 50);
                }}
              />
            }
            {!sufixIcon ? (
              <></>
            ) : (
              <span className={`${styles.icon} ${styles.right}`}>{sufixIcon}</span>
            )}
          </div>
        </div>
        <span
          className={`${styles.optionIcon} ${isActiveOption ? styles.active : ""
            }`}
          onClick={onClick}
        ></span>
      </div>
    );
  }
);

export const Title = ({ text = "", classes = "" }) => {
  return <h1 className={`${styles.Title} ${classes}`}>{text}</h1>;
};

export const Header = ({ text = "", classes = "" }) => {
  return <h1 className={`${styles.Header} ${classes}`}>{text}</h1>;
};

export const Headline = ({ text = "", classes = "" }) => {
  return <h2 className={`${styles.Headline} ${classes}`}>{text}</h2>;
};

export const SubTitle = ({ text = "", classes = "" }) => {
  return <h3 className={`${styles.SubTitle} ${classes}`}>{text}</h3>;
};

export const SubHeader = ({ text = "", classes = "" }) => {
  return <h6 className={`${styles.SubHeader} ${classes}`}>{text}</h6>;
};

export const SubHeadline = ({ text = "", classes = "" }) => {
  return <h6 className={`${styles.SubHeadline} ${classes}`}>{text}</h6>;
};

export const LabelHeader = ({ text = "", classes = "", onClick }) => {
  return (
    <h6 className={`${styles.LabelHeader} ${classes}`} onClick={onClick}>
      {text}
    </h6>
  );
};

export const Description = ({
  text = "",
  size = "55",
  classes = "",
  onClick = () => { },
}) => {
  return (
    <p
      className={`${styles.Description} ${classes} fs-${size}`}
      onClick={onClick}
    >
      {text}
    </p>
  );
};

export const DescriptionLight = ({
  text = "",
  size = "7",
  classes = "",
  onClick = () => { },
}) => {
  return (
    <p
      className={`${styles.DescriptionLight} ${classes} fs-${size}`}
      onClick={onClick}
    >
      {text}
    </p>
  );
};

export const Button = ({
  text = "",
  classes = "",
  style = {},
  onClick = () => { },
  disabled = false,
  isSubmitted = false,
  bordered = false,
  type = "",
  lightTheme = false,
  success = false,
  fail = false,
  prefixIcon = undefined,
  text_gradient = false,
  spinner_classes = "",
}) => {
  return (
    <button
      className={`
        ${styles.Button} ${classes}
        ${isSubmitted || disabled ? styles.disabled : ""}
        ${bordered ? styles.bordered : ""}
        ${lightTheme ? styles.lightTheme : ""}
        ${success ? styles.success : ""}
        ${fail ? styles.fail : ""}
        `}
      style={{
        ...style,
        color: text_gradient ? "transparent" : "#000000",
      }}
      type={type}
      onClick={!disabled ? onClick : () => { }}
    >
      {!prefixIcon ? (
        ""
      ) : (
        <span className={styles.prefixIcon}>{prefixIcon}</span>
      )}
      {text}
      {isSubmitted ? (
        <Spinner size="sm" className={`ms-3 ${spinner_classes}`} />
      ) : (
        ""
      )}
    </button>
  );
};

export const ProgressBar = ({
  text = "",
  classes = "",
  percentage = 0,
  iconClasses = "",
}) => {
  return (
    <button
      className={`
        ${styles.ProgressBar} ${classes}
        `}
    >
      <div
        className={styles.progress}
        style={{ width: `${percentage}%` }}
      ></div>
      <span
        className={`${styles.percentage} ${iconClasses}`}
      >{`${percentage} %`}</span>
      <span>{text}</span>
    </button>
  );
};

export const TextDivider = ({ text = "", classes = "" }) => {
  return <div className={`${styles.TextDivider} ${classes}`}>{text}</div>;
};

export const UnorderedList = ({
  lists = [],
  classes = "",
  item_classes = "",
}) => {
  return (
    <ul className={`${styles.UL} ${classes} fs-7`}>
      {lists.map((item, index) => (
        <li key={index} className={`${item_classes} fs-7`}>
          {item}
        </li>
      ))}
    </ul>
  );
};

export const Checkbox = ({
  label = "",
  classes = "",
  type = "checkbox",
  // checked = false,
  group,
  onChange = () => { },
}) => {
  return (
    <Form.Check
      type={type}
      className={`${styles.Checkbox} ${classes}`}
      label={label}
      name={group}
      // checked={checked}
      onChange={onChange}
    />
  );
};

export const SearchInput = ({
  placeholder = "Search Here",
  value,
  setValue,
  boxShadow = false,
}) => {
  return (
    <div
      className={`${styles.SearchInput} ${boxShadow ? styles.boxShadow : ""}`}
    >
      <div className={styles.searchButton}>
        <AiOutlineSearch size={25} />
      </div>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      />
    </div>
  );
};

export const Tag = ({
  text = "Tag",
  classes = "",
  color = "white",
  backgroundColor = "red",
}) => {
  return (
    <span
      className={`${styles.Tag} ${classes}`}
      style={{ color: color, backgroundColor: backgroundColor }}
    >
      {text}
    </span>
  );
};

export const UploadButton = ({
  label = "Upload",
  classes = "",
  labelClasses = "p-4",
  isMultileFileUpload = false,
  fileAcceptParams = "",
  file = {},
  handleFileChange = () => { },
  isActiveOption = false,
  onClick = () => { },
  isSelect = false,
  cover_image_url,
  ...rest
}) => {
  const renderFilePreview = () => {
    if (!file) return null;

    if (typeof file === 'string') {
      return <img
        src={file}
        alt="Preview"
        className={styles.imagePreview}
      />
    }
    if (file.type?.startsWith("image")) {
      return (
        <img
          src={URL.createObjectURL(file)}
          alt="Preview"
          className={styles.imagePreview}
        />
      );
    } else if (file.type?.startsWith("video")) {
      return (
        <video controls className={styles.videoPreview}>
          <source src={URL.createObjectURL(file)} type={file.type} />
        </video>
      );
    } else if (file.type === "application/pdf") {
      return (
        <embed
          src={URL.createObjectURL(file)}
          type="application/pdf"
          className={styles.pdfPreview}
        />
      );
    } else {
      return <span>Selected file: {file.name}</span>;
    }
  };

  return (
    <div className={`${styles.UploadButton} ${classes}`}>
      <input
        type="file"
        id="file-upload"
        className={styles.uploadInput}
        onChange={handleFileChange}
        multiple={isMultileFileUpload}
        accept={fileAcceptParams}
      />
      <label
        htmlFor="file-upload"
        className={`${styles.uploadLabel} ${labelClasses} ${(_.isObject(file) || !_.isEmpty(file)) ? styles.fileUploaded : ""
          }`}
      >
        {cover_image_url ? (
          <img
            src={cover_image_url}
            className={styles.imagePreview}
            alt="Preview"
          />
        ) : ((typeof file.name !== 'string') && _.isEmpty(file)) ? (
          <>
            <span className={styles.icon}>
              <CameraIcon />
            </span>
            <span>{label}</span>
          </>
        ) : (
          renderFilePreview()
        )}
      </label>
      {isSelect && (
        <span
          className={`${styles.optionIcon} ${isActiveOption ? styles.active : ""
            }`}
          onClick={onClick}
        ></span>
      )}
    </div>
  );
};

export const Select = ({
  classes = "mt-1 mb-2",
  labelContainerClasses = "",
  label = "",
  labelClasses = "",
  labelItem = undefined,
  inputClasses = "",
  selected = "",
  handleChange = () => { },
  options = [],
  isDownIcon = true,
  disabled = false
}) => {
  const activeOption =
    options.find((item) => item.value === selected) || options[0];
  const dropdownRef = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function handleClickOutside(event) {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  }

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const selectOption = (option) => {
    handleChange(option.value);
    setIsDropdownOpen(false);
  };

  return (
    <div className={`${styles.Select} ${classes}`} ref={dropdownRef}>
      {!label && !labelItem ? (
        ""
      ) : (
        <div
          className={`d-flex flex-row align-items-center ${labelContainerClasses}`}
        >
          {!label ? (
            ""
          ) : (
            <LabelHeader
              text={label}
              classes={`${styles.label} ${labelClasses}`}
            />
          )}
          {!labelItem ? "" : labelItem}
        </div>
      )}
      <div className={styles.SelectContainer}>
        <div className={styles.header} onClick={disabled ? () => { } : toggleDropdown}>
          <span
            className={`${styles.label} ${!selected ? styles.placeholder : ""}`}
          >
            {activeOption.label || "Select"}
          </span>
          {isDownIcon && (
            <span className={styles.icon}>
              <IoChevronDownSharp size={20} color="white" />
            </span>
          )}
        </div>
        {isDropdownOpen && (
          <ul className={`${styles.FormSelectList} ${inputClasses}`}>
            {options.map((item) => {
              return (
                <li
                  key={item.value}
                  className={`${styles.option} ${activeOption.value === item.value ? styles.active : ""
                    }`}
                  onClick={() => selectOption(item)}
                >
                  {item.label}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
};
export const SmallButton = ({
  text = "",
  classes = "",
  style = {},
  onClick = () => { },
  disabled = false,
  isSubmitted = false,
  bordered = false,
  type = "",
  color = "rgba(217, 217, 217, 0.2)",
  single = false,
}) => {
  return (
    <button
      className={`${styles.SmallButton} ${classes} ${isSubmitted || disabled ? styles.disabled : ""
        } ${bordered ? styles.bordered : ""} ${single ? styles.single : ""}`}
      style={{ ...style, backgroundColor: color }}
      type={type}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
    >
      {text}
      {isSubmitted ? <Spinner size="sm" className="ms-3" /> : ""}
    </button>
  );
};

export const CloseButton = ({ classes = "", onClick = () => { } }) => {
  return (
    <div className={`${styles.CloseButton} ${classes}`} onClick={onClick}>
      <IoCloseOutline size={18} color="white" />
    </div>
  );
};
